import { AdminApiError, type AdminEnvelope, get } from './_core.js';

export interface PricingRow {
  id: string;
  provider: string;
  model: string;
  serviceKind: string;
  inputNanoPerMtok: string | null;
  outputNanoPerMtok: string | null;
  cacheReadNanoPerMtok: string | null;
  cacheWriteNanoPerMtok: string | null;
  nanoPerChar: string | null;
  nanoPerSecond: string | null;
  nanoPerMinute: string | null;
  active: boolean;
  effectiveFrom: string;
  notes: string | null;
}

export async function fetchPricing(): Promise<{ rows: PricingRow[] }> {
  const res = await get<{ rows: PricingRow[] }>('/admin/pricing');
  return res.data;
}

export interface NewPricingInput {
  provider: string;
  model: string;
  serviceKind: string;
  inputNanoPerMtok?: string | undefined;
  outputNanoPerMtok?: string | undefined;
  cacheReadNanoPerMtok?: string | undefined;
  cacheWriteNanoPerMtok?: string | undefined;
  nanoPerChar?: string | undefined;
  nanoPerSecond?: string | undefined;
  nanoPerMinute?: string | undefined;
  notes?: string | undefined;
}

export async function postPricing(input: NewPricingInput): Promise<{ id: string }> {
  const res = await fetch('/api/admin/pricing', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(input),
  });
  const json = (await res.json().catch(() => null)) as AdminEnvelope<{ id: string }> | null;
  if (!res.ok || !json || !('success' in json) || json.success !== true) {
    const code = json && 'error' in json ? json.error.code : 'pricing_failed';
    const msg = json && 'error' in json ? json.error.message : 'pricing failed';
    throw new AdminApiError(res.status, code, msg);
  }
  return json.data;
}
